<template>
	<div class="home_wrap">
		<div class="backgroud_bg">
			<img src="../images/index/res-bg.png" alt="" style="width: 100%;">
		</div>
		<div class="bengin_act">
			<div class="bengin_btn">
				精彩活动,正在路上
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {WOW} from 'wowjs'
	import { swiper, swiperSlide } from "vue-awesome-swiper";
	import "swiper/dist/css/swiper.css";
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"
	
	import {
		Swipe,
		SwipeItem,
		Icon,
		Progress,
		Dialog,
		Field,
		Circle,
		Switch
	} from "vant";

	Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(Circle).use(Switch);

	export default {
		name: "Index",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
			swiper,
			swiperSlide
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
			};
		},
		created() {
			this.$parent.footer('index',false);
		},
		watch: {
		},
		mounted() {
			this.start();
		},
		methods: {
			start(){
				
			},
		}
	};
</script>

<style lang="less" scoped>
	.backgroud_bg{
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
	}
	.home_wrap {
		
	}
	.bengin_act {
	    position: absolute;
	    width: 100%;
	    z-index: 9;
	    top: 30vh;
		
		.bengin_btn {
		    text-align: center;
			font-size: 0.65rem;
			color: #f5e504;
		}
	}
</style>
